import createStore from "astrid-helpers/src/createStore";
export const [getLabel, setLabel, useLabel] = createStore();
//# sourceMappingURL=label.js.map